<template>
  <div
    class="dropdown-item-wrapper"
    @mouseover="onMouseover"
    @mouseout="onMouseout"
  >
    <button
      :id="buttonId"
      class="header-menu__item"
      type="button"
      role="menuitem"
      aria-haspopup="true"
      :aria-expanded="expanded ? 'true' : 'false'"
      :aria-controls="menuId"
      @keydown.enter="toggle"
      @keydown.space="toggle"
    >
      {{ item.name }}
    </button>
    <HeaderDropdownMenu
      @hide-menu="onMouseout"
      :id="menuId"
      :aria-labelledby="buttonId"
      :menu="item.menu"
      :expanded="expanded"
    />
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid';
import HeaderDropdownMenu from '@/components/HeaderDropdownMenu.vue';

export default {
  name: 'HeaderNavigationDropdownItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    HeaderDropdownMenu,
  },
  data() {
    return {
      expanded: false,
      buttonId: `id${uuid()}`,
      menuId: `id${uuid()}`,
    };
  },
  mounted() {

  },
  methods: {
    onMouseover() {
      if (!this.expanded) {
        this.expanded = true;
      }
    },
    onMouseout() {
      this.expanded = false;
    },
    onBlur(evt) {
      console.log(evt);
    },
    toggle() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style lang="scss">
.dropdown-item-wrapper {
  position: relative;

  display: inherit;
  align-items: center;
  height: 100%;

  .header-dropdown-menu {
    position: absolute;
    bottom: 0;
    left: 50%;
    z-index: 100;
    transform: translate(-50%, calc(100% - 0.5rem));
  }
}
</style>
